/**
 * Product page (Figma: Product_Landing_Page) — tabs, "Skatīt vairāk", spec table into its tab, customer videos.
 * Clicks use event delegation, and setup re-runs when the theme re-renders the buy box after a variant change.
 */
(function () {
  // Moves the "Specification & Compare" app block into the Specifikācija tab. The app block is on every product,
  // also when that product has no specification (then it draws an empty table), so the tab only shows once the
  // app has drawn at least one specification row; until then — and for products without a table — it stays hidden.
  function setupSpec(root) {
    root.querySelectorAll("[data-emk-tabs]").forEach(function (tabs) {
      var panel = tabs.querySelector("[data-emk-spec-panel]");
      var tab = tabs.querySelector("[data-emk-tab-spec]");
      if (!panel || !tab) return;
      if (!panel.childElementCount) {
        var form = tabs.closest("form") || document;
        var spec = form.querySelector(".product-info__block-item .sc-app-block");
        var item = spec && spec.closest(".product-info__block-item");
        if (!item) return;
        panel.appendChild(item);
      }
      updateSpecTab(tabs);
    });
    fixSpecLines(root);
  }

  // True when the app's table (shadow DOM) has at least one specification row
  function specHasRows(panel) {
    var tables = panel.querySelectorAll("sc-specification-table");
    for (var i = 0; i < tables.length; i++) {
      var shadow = tables[i].shadowRoot;
      if (shadow && shadow.querySelector(".row--attribute")) return true;
    }
    return false;
  }

  function updateSpecTab(tabs) {
    var panel = tabs.querySelector("[data-emk-spec-panel]");
    var tab = tabs.querySelector("[data-emk-tab-spec]");
    if (!panel || !tab) return;
    var show = specHasRows(panel);
    if (tab.hidden === !show) return;
    tab.hidden = !show;
    // The spec tab was open and turned out empty: go back to Apraksts
    if (!show && tab.getAttribute("aria-selected") === "true") {
      var first = tabs.querySelector('[role="tab"]');
      if (first && first !== tab) selectTab(first);
    }
    if (show) fixSpecLines(panel);
  }

  // The app fills its table in its own shadow DOM after page load (no event for that), so check again for a while
  (function watchSpec() {
    var tries = 0;
    var timer = setInterval(function () {
      document.querySelectorAll("[data-emk-tabs]").forEach(updateSpecTab);
      if (++tries >= 40) clearInterval(timer); // ~20 s
    }, 500);
  })();

  // The app draws a line above and below every row; neighbours overlap and look doubled on scaled screens.
  // Keep one line per row (below), plus the line under the group heading (Figma 36:2379).
  function fixSpecLines(root) {
    root.querySelectorAll("sc-specification-table").forEach(function (table) {
      var shadow = table.shadowRoot;
      if (!shadow || shadow.querySelector("style[data-emk]")) return;
      var style = document.createElement("style");
      style.setAttribute("data-emk", "");
      style.textContent =
        ".row--attribute { border-top-width: 0 !important; }" +
        ".row--group + .row--attribute { border-top-width: 1px !important; }";
      shadow.appendChild(style);
    });
  }

  /*
   * "Skatīt vairāk" long description. Desktop (two columns, ≥1000px): it opens in the left column under the gallery,
   * so the buy box on the right stays compact and both columns even out. Phone/tablet: inline in the Apraksts tab.
   * The left copy is made on demand from the hidden .emk-tabs__more (no duplicate text in the page source).
   */
  var desktopQuery = window.matchMedia("(min-width: 1000px)");

  function leftMoreFor(more, create) {
    var list = more.closest(".product-block-list");
    var wrapper = list && list.querySelector(".product-block-list__wrapper");
    var gallery = wrapper && wrapper.querySelector(".product-block-list__item--gallery");
    if (!gallery) return null; // no gallery = nothing on the left to balance, stay inline
    var box = wrapper.querySelector("[data-emk-more-left]");
    if (!box && create) {
      box = document.createElement("div");
      box.className = "product-block-list__item emk-more-left";
      box.setAttribute("data-emk-more-left", "");
      box.hidden = true;
      box.innerHTML = '<div class="card"><div class="card__section"><div class="emk-tabs__content rte"></div></div></div>';
      gallery.insertAdjacentElement("afterend", box);
    }
    return box;
  }

  function placeMore(more) {
    var panel = more.closest(".emk-tabs__panel");
    var extra = panel && panel.querySelector(".emk-tabs__more");
    if (!extra) return;
    var open = more.getAttribute("aria-expanded") === "true";
    var box = desktopQuery.matches ? leftMoreFor(more, open) : null;
    if (box) {
      var content = box.querySelector(".emk-tabs__content");
      if (open && !content.childElementCount) content.innerHTML = extra.innerHTML;
      box.hidden = !open;
      extra.hidden = true;
      evenColumns();
    } else {
      var list = more.closest(".product-block-list");
      var leftBox = list && list.querySelector("[data-emk-more-left]");
      if (leftBox) leftBox.hidden = true;
      extra.hidden = !open;
    }
  }

  // Desktop: both columns end on one line. Left column = gallery (+ the "Skatīt vairāk" text card when open).
  // Left taller → the buy box is stretched to it; buy box taller → the open text card is stretched down to it (closed:
  // the sticky gallery already stops at the column bottom). Measured from natural heights each time, so nothing stays
  // stretched after the content gets shorter. Re-run when either column changes size and on window resize.
  function evenColumns() {
    document.querySelectorAll(".product-block-list__wrapper").forEach(function (wrapper) {
      var gallery = wrapper.querySelector(":scope > .product-block-list__item--gallery");
      var info = wrapper.querySelector(":scope > .product-block-list__item--info > .card");
      if (!gallery || !info) return;
      var box = wrapper.querySelector(":scope > [data-emk-more-left]");
      var boxCard = box && box.querySelector(":scope > .card");
      info.style.removeProperty("min-height");
      if (boxCard) boxCard.style.minHeight = "";
      if (!wrapper.emkObserved && window.ResizeObserver) {
        wrapper.emkObserved = true;
        // Straight from the observer (no requestAnimationFrame: it can be skipped, which left a stale height)
        var ro = new ResizeObserver(function () { evenColumns(); });
        ro.observe(gallery);
        ro.observe(info);
        ro.observe(info.querySelector("form") || info);
        // The theme rewrites the column height from its own observer; put ours back whenever it differs
        new MutationObserver(function () {
          if (wrapper.emkMin && wrapper.style.minHeight !== wrapper.emkMin) wrapper.style.minHeight = wrapper.emkMin;
        }).observe(wrapper, { attributes: true, attributeFilter: ["style"] });
      }
      info.style.transform = "";
      wrapper.emkStickInfo = false;
      if (!desktopQuery.matches) { wrapper.emkMin = ""; return; } // phone/tablet: the theme's own height
      var open = box && !box.hidden && boxCard;
      var left = gallery.offsetHeight + (open ? box.offsetHeight + (parseFloat(getComputedStyle(box).marginTop) || 0) : 0);
      var right = info.offsetHeight;
      // Left taller (e.g. "Skatīt vairāk" text open): the buy box keeps its own height — no empty space in it — and
      // stays in view while scrolling, then stops with its bottom on one line with the left column (see stickInfo)
      if (left > right + 1) wrapper.emkStickInfo = true;
      else if (open && right > left + 1) boxCard.style.minHeight = Math.round(boxCard.offsetHeight + right - left) + "px";
      // The theme sets this min-height from the buy box once and can keep an old, taller value (the sticky gallery then
      // ran ~40px past the buy box). Set it to the evened column height; runs a frame after the theme's own observer.
      wrapper.emkMin = Math.ceil(Math.max(left, info.offsetHeight)) + "px";
      if (wrapper.style.minHeight !== wrapper.emkMin) wrapper.style.minHeight = wrapper.emkMin;
      stickInfo(wrapper);
    });
  }

  // "Sticky" buy box: the theme pins the right column with position: absolute + top: 0 + height: 100% (all !important),
  // so the card inside it is moved instead (translateY) — down with the page under the sticky header (+ red countdown
  // bar, same offset as the gallery), never past the bottom of the column = the bottom of the left column
  function stickInfo(wrapper) {
    var card = wrapper.querySelector(":scope > .product-block-list__item--info > .card");
    if (!card) return;
    if (!wrapper.emkStickInfo || !desktopQuery.matches) { if (card.style.transform) card.style.transform = ""; return; }
    var root = getComputedStyle(document.documentElement);
    var offset = (parseInt(root.getPropertyValue("--header-height"), 10) || 0) * (parseInt(root.getPropertyValue("--header-is-sticky"), 10) || 0) +
      (parseInt(root.getPropertyValue("--emk-countdown-height"), 10) || 0) + 20;
    var max = card.parentElement.offsetHeight - card.offsetHeight;
    var colTop = card.parentElement.getBoundingClientRect().top;
    // Fits on screen: sticks under the header. Taller than the screen: scrolls normally until its bottom is in view,
    // then that bottom stays in view — so every part of the buy box can still be reached
    var want = card.offsetHeight <= window.innerHeight - offset - 20
      ? offset - colTop
      : window.innerHeight - 20 - colTop - card.offsetHeight;
    var y = Math.round(Math.min(Math.max(want, 0), Math.max(max, 0)));
    var t = y ? "translateY(" + y + "px)" : "";
    if (card.style.transform !== t) card.style.transform = t;
  }
  window.addEventListener("scroll", function () {
    document.querySelectorAll(".product-block-list__wrapper").forEach(function (w) { if (w.emkStickInfo) stickInfo(w); });
  }, { passive: true });
  window.addEventListener("resize", evenColumns);
  window.addEventListener("load", evenColumns);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", evenColumns);
  else evenColumns();

  // After "Skatīt vairāk" opens, scroll to the opened text: on desktop the copy in the left column under the gallery,
  // on phone/tablet the text inside the Apraksts tab. Its top lands just under the sticky header (+ red countdown bar).
  // Before, it only scrolled on desktop when the text started below the screen — opened from further down the page,
  // the text appeared above the screen and nothing moved.
  function revealLeftMore(more) {
    var target = null;
    if (desktopQuery.matches) {
      var list = more.closest(".product-block-list");
      target = list && list.querySelector("[data-emk-more-left]");
    }
    if (!target || target.hidden) {
      var panel = more.closest(".emk-tabs__panel");
      target = panel && panel.querySelector(".emk-tabs__more");
    }
    if (!target || target.hidden) return;
    var root = getComputedStyle(document.documentElement);
    var header = (parseInt(root.getPropertyValue("--header-height"), 10) || 0) * (parseInt(root.getPropertyValue("--header-is-sticky"), 10) || 0);
    var offset = header + (parseInt(root.getPropertyValue("--emk-countdown-height"), 10) || 0) + 20;
    var top = target.getBoundingClientRect().top; // measuring forces the new layout, no need to wait a frame
    if (Math.abs(top - offset) < 8) return;
    window.scrollTo({ top: window.pageYOffset + top - offset, behavior: "smooth" });
  }

  // Crossing the 1000px breakpoint while open moves the text to the right place
  function replaceAllMore() {
    document.querySelectorAll("[data-emk-more]").forEach(placeMore);
  }
  if (desktopQuery.addEventListener) desktopQuery.addEventListener("change", replaceAllMore);
  else if (desktopQuery.addListener) desktopQuery.addListener(replaceAllMore);

  function selectTab(tab) {
    var tabs = tab.closest("[data-emk-tabs]");
    tabs.querySelectorAll('[role="tab"]').forEach(function (t) {
      var active = t === tab;
      t.setAttribute("aria-selected", active ? "true" : "false");
      t.tabIndex = active ? 0 : -1;
      var panel = document.getElementById(t.getAttribute("aria-controls"));
      if (panel) panel.hidden = !active;
    });
  }

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target.closest) return;

    var tab = target.closest("[data-emk-tabs] [role='tab']");
    if (tab) {
      selectTab(tab);
      return;
    }

    var more = target.closest("[data-emk-more]");
    if (more) {
      var label = more.querySelector("[data-emk-more-label]");
      var open = more.getAttribute("aria-expanded") !== "true";
      more.setAttribute("aria-expanded", open ? "true" : "false");
      if (label) {
        if (!label.dataset.more) label.dataset.more = label.textContent;
        label.textContent = open ? label.dataset.less : label.dataset.more;
      }
      placeMore(more);
      if (open) revealLeftMore(more);
      return;
    }

    // Family switcher: a mouse drag along the row must not open the card under the pointer
    if (dragMoved && target.closest("[data-emk-family]")) { event.preventDefault(); return; }

    // Customer videos: first tap plays with sound and controls (not at the end of a mouse drag)
    var item = target.closest("[data-emk-cvideo]");
    if (item && dragMoved) { event.preventDefault(); return; }
    if (item && !item.classList.contains("is-playing")) {
      var video = item.querySelector("video");
      if (!video) {
        // Cover image only: put the player from the <template> in its place
        var template = item.querySelector("template");
        video = template && template.content.querySelector("video");
        if (!video) return;
        video = document.importNode(video, true);
        item.textContent = "";
        item.appendChild(video);
      }
      loadVideo(video);
      item.classList.add("is-playing");
      video.muted = false;
      video.controls = true;
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    }
  });

  // Keyboard: arrow keys move between tabs
  document.addEventListener("keydown", function (event) {
    var tab = event.target.closest && event.target.closest("[data-emk-tabs] [role='tab']");
    if (!tab || (event.key !== "ArrowRight" && event.key !== "ArrowLeft")) return;
    var list = Array.prototype.filter.call(tab.parentNode.querySelectorAll('[role="tab"]'), function (t) { return !t.hidden; });
    var next = list[(list.indexOf(tab) + (event.key === "ArrowRight" ? 1 : -1) + list.length) % list.length];
    selectTab(next);
    next.focus();
  });

  // Benefits carousel (phone): highlight the dot of the visible benefit
  function updateBenefitDots(list) {
    var dots = list.parentNode.querySelectorAll(".emk-benefits__dots span");
    if (!dots.length) return;
    var index = Math.round(list.scrollLeft / Math.max(list.clientWidth, 1));
    dots.forEach(function (dot, i) { dot.classList.toggle("is-active", i === index); });
  }

  // Rows that scroll sideways with a grey bar
  var ROWS = "[data-emk-cvideos], [data-emk-family]";

  // Customer videos and the family switcher: grey progress bar under the row
  document.addEventListener("scroll", function (event) {
    var track = event.target;
    if (track.matches && track.matches("[data-emk-benefits]")) { updateBenefitDots(track); return; }
    if (!track.matches || !track.matches(ROWS)) return;
    if (track.matches("[data-emk-family]")) {
      // Family switcher: mark the sides that have more cards (the soft edge in emk-product.css)
      track.classList.toggle("has-prev", track.scrollLeft > 4);
      track.classList.toggle("has-next", track.scrollLeft < track.scrollWidth - track.clientWidth - 4);
    }
    var thumb = track.parentNode.querySelector("[data-emk-cvideos-thumb], [data-emk-family-thumb]");
    if (!thumb) return;
    var ratio = track.clientWidth / track.scrollWidth;
    thumb.style.width = ratio * 100 + "%";
    thumb.style.transform = "translateX(" + (track.scrollLeft / track.clientWidth) * 100 + "%)";
  }, true);

  // Customer videos and the family switcher on desktop: drag the row with the mouse, or drag / click the grey bar
  var dragMoved = false;
  var drag = null;

  document.addEventListener("pointerdown", function (event) {
    if (event.pointerType !== "mouse" || event.button !== 0 || !event.target.closest) return;
    var bar = event.target.closest(".emk-cvideos__bar, .emk-family__bar");
    var track = bar ? bar.parentNode.querySelector(ROWS) : event.target.closest(ROWS);
    if (!track || track.scrollWidth <= track.clientWidth) return;
    dragMoved = false;
    drag = { track: track, bar: bar, startX: event.clientX, startLeft: track.scrollLeft };
    track.style.scrollSnapType = "none";
    track.style.scrollBehavior = "auto";
    if (bar) {
      // Click on the bar: jump so the thumb centres under the pointer
      var rect = bar.getBoundingClientRect();
      var ratio = (event.clientX - rect.left) / rect.width;
      track.scrollLeft = ratio * track.scrollWidth - track.clientWidth / 2;
      drag.startLeft = track.scrollLeft;
    }
    event.preventDefault();
  });

  document.addEventListener("pointermove", function (event) {
    if (!drag) return;
    var dx = event.clientX - drag.startX;
    if (Math.abs(dx) > 5) dragMoved = true;
    if (drag.bar) {
      // Bar: move in proportion to the whole row
      drag.track.scrollLeft = drag.startLeft + dx * (drag.track.scrollWidth / drag.bar.clientWidth);
    } else {
      drag.track.scrollLeft = drag.startLeft - dx;
    }
  });

  document.addEventListener("pointerup", function () {
    if (!drag) return;
    var track = drag.track;
    drag = null;
    track.style.scrollSnapType = "";
    track.style.scrollBehavior = "";
    // Let the click that follows this pointerup see dragMoved, then reset
    setTimeout(function () { dragMoved = false; }, 0);
  });

  // Customer videos given as a plain .mp4 link have no cover image: set their src (first frame) only once the page
  // has loaded and the row is near the screen, so they don't compete with the rest of the page
  function loadVideo(video) {
    var src = video.getAttribute("data-emk-src");
    if (!src) return;
    video.removeAttribute("data-emk-src");
    video.preload = "metadata";
    video.src = src;
  }

  var videoObserver = null;
  var pageLoaded = document.readyState === "complete";

  function watchVideos() {
    if (!pageLoaded) return;
    document.querySelectorAll("video[data-emk-src]").forEach(function (video) {
      if (!("IntersectionObserver" in window)) { loadVideo(video); return; }
      videoObserver = videoObserver || new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          videoObserver.unobserve(entry.target);
          loadVideo(entry.target);
        });
      }, { rootMargin: "200px" });
      videoObserver.observe(video);
    });
  }

  window.addEventListener("load", function () { pageLoaded = true; watchVideos(); });

  function init() {
    setupSpec(document);
    // After a variant re-render the button is collapsed again: keep the left-column text in sync
    document.querySelectorAll("[data-emk-more]").forEach(placeMore);
    document.querySelectorAll("[data-emk-benefits]").forEach(updateBenefitDots);
    // Family switcher: a long row (e.g. 22 Bestie prints) starts at the current card when it is out of view
    document.querySelectorAll("[data-emk-family]:not([data-emk-family-ready])").forEach(function (track) {
      track.setAttribute("data-emk-family-ready", "");
      var current = track.querySelector(".is-current");
      if (!current) return;
      var left = current.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      if (left + current.offsetWidth > track.clientWidth) track.scrollLeft = left - (track.clientWidth - current.offsetWidth) / 2;
    });
    document.querySelectorAll(ROWS).forEach(function (track) {
      track.dispatchEvent(new Event("scroll"));
    });
    watchVideos();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  // The theme swaps the buy box HTML when a variant changes
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; init(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/**
 * Review box under the title (snippets/emk-product-review-box.liquid) links to the Judge.me reviews further down:
 * smooth scroll there; when the page has no reviews widget the box stays plain (link removed).
 */
(function () {
  function target() {
    return document.getElementById("judgeme_product_reviews");
  }

  function setup() {
    if (target()) return;
    document.querySelectorAll("[data-emk-review-link]").forEach(function (box) {
      box.removeAttribute("href");
    });
  }

  document.addEventListener("click", function (event) {
    var box = event.target.closest && event.target.closest("[data-emk-review-link][href]");
    var reviews = box && target();
    if (!reviews) return;
    event.preventDefault();
    reviews.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", setup);
  else setup();
})();
